import React from "react";

export const Footer: React.FC = () => {
  return (
    <footer className="footer">
      © Ministarstvo poljoprivrede, šumarstva i ribarstva 2025. Sva prava pridržana.
    </footer>
  );
};
